<template>
<div>
    <sub-category-form 
        :is-sub-category-form-sidebar-active.sync="isSubCategoryFormSidebarActive"
        :sub-category-data="subCategoryData"
        @refetch-data="refetchSubCategoryData"
    />
    <b-card no-body>
        <div class="m-2">
            <b-row>
                <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0" ></b-col>
                <b-col cols="12" md="6" >
                    <div class="d-flex align-items-center justify-content-end">
                        <b-form-input
                            v-model="searchQuery"
                            class="d-inline-block mr-1"
                            placeholder="Search..."
                        />
                        <b-button variant="primary" @click="updateSubCategory()">
                            <span class="text-nowrap">Add Sub Category</span>
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </div>
        <b-table
            ref="refSubCategoryListTable"
            :items="foodSubCategories"
            responsive
            :fields="tableColumns"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="No matching records found"
            :sort-desc.sync="isSortDirDesc"
            class="position-relative"
        >
            <!-- <template #cell(cover_image)="data">
                <b-img
                    :src="data.item.files[0].path || ''"
                    width="150"
                    class="rounded m-0"
                />
            </template> -->
            <template #cell(title)="data">
                {{ data.item.title[currentLocale] }}
            </template>
            <template #cell(slug)="data">
                {{ data.item.slug[currentLocale] }}
            </template>
            <template #cell(is_active)="data">
                <b-badge
                    pill
                    :variant="`light-${resolveSubCategoryStatusVariant(data.item.is_active)}`"
                    class="text-capitalize"
                >
                    {{ resolveSubCategoryStatusnameVariant(data.item.is_active) }} 
                </b-badge>
            </template>
            <template #cell(action)="data">
                <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateSubCategory(data.item)" variant="outline-success">Edit</b-button>
                <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(data.item.id)" variant="outline-danger">Delete</b-button>
            </template>
        </b-table>
        <div class="mx-2 mb-2">
            <b-row>
                <b-col cols="12" sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start" >
                    <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                </b-col>
                <b-col cols="12" sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end" >
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalfoodSubCategories"
                        :per-page="perPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                    >
                        <template #prev-text>
                            <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                            />
                            </template>
                            <template #next-text>
                            <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                            />
                        </template>
                    </b-pagination>
                </b-col>
            </b-row>
        </div>
    </b-card>
</div>
</template>

<script>
    import {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BImg,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox
    } from 'bootstrap-vue';
    import { ref, onUnmounted } from '@vue/composition-api'
    import { MenuIcon } from 'vue-feather-icons'
    import store from '@/store'
    import draggable from 'vuedraggable'
    import Ripple from 'vue-ripple-directive';
    import useSubCategoryList from '../sub-category-list/useSubCategoryList'
    import SubCategoryForm from './SubCategoryForm.vue';
    import foodStoreModule from '../foodStoreModule';

    export default {
        components: {
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox,
            draggable, MenuIcon, SubCategoryForm, BImg,
        },
        directives: {
            'b-modal': VBModal,
            Ripple
        },
        computed: {
            currentLocale() {
                return  this.$i18n.locale;
            },
        },
        setup() {
            const CAT_STORE_MODULE_NAME = 'app-food';
            if (!store.hasModule(CAT_STORE_MODULE_NAME)) store.registerModule(CAT_STORE_MODULE_NAME, foodStoreModule)
            
            onUnmounted(() => {
                if (store.hasModule(CAT_STORE_MODULE_NAME)) store.unregisterModule(CAT_STORE_MODULE_NAME)
            });

            const {
                isSubCategoryFormSidebarActive,
                subCategoryData,
                refetchSubCategoryData,
                updateSubCategory,
                searchQuery,
                refSubCategoryListTable,
                foodSubCategories,
                tableColumns,
                sortBy,
                isSortDirDesc,
                fetchSubCategoryData,
                resolveSubCategoryStatusVariant,
                resolveSubCategoryStatusnameVariant,
                dataMeta,
                totalfoodSubCategories,
                perPage,
                currentPage,
                deleteData,
            } = useSubCategoryList()

            fetchSubCategoryData()

            return {
                isSubCategoryFormSidebarActive,
                subCategoryData,
                refetchSubCategoryData,
                updateSubCategory,
                searchQuery,
                refSubCategoryListTable,
                foodSubCategories,
                tableColumns,
                sortBy,
                isSortDirDesc,
                fetchSubCategoryData,
                resolveSubCategoryStatusVariant,
                resolveSubCategoryStatusnameVariant,
                dataMeta,
                totalfoodSubCategories,
                perPage,
                currentPage,
                deleteData,
            }
        },
        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm(`Please confirm that you want to delete data ID = ${id}`, {
                        title: 'Please Confirm',
                        size: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                        if(value === true){
                        this.deleteData(id)
                    }
                })
            },
        }
    }
</script>